/**
 * Whether a usage read accounts for every environment: none failed, none
 * excluded for an older contract, none still answering, and no environment
 * reported a gap in its own read. Only then is a merged total the whole of
 * it; otherwise it is what has been counted so far.
 *
 * A ledger counted once across environments that share it is not a gap.
 *
 * @module usage/usageCoverage
 */

export interface UsageCoverageInput {
  readonly environments: ReadonlyArray<{ readonly environmentId: string; readonly error: string | null }>;
  readonly staleEnvironments: ReadonlyArray<string>;
  readonly coverageNotices: ReadonlyArray<string>;
  readonly isPartial: boolean;
}

export function usageCoverageComplete(input: UsageCoverageInput): boolean {
  if (input.isPartial || input.coverageNotices.length > 0) return false;
  return input.environments.every(
    (environment) => environment.error === null && !input.staleEnvironments.includes(environment.environmentId),
  );
}
